import * as React from 'react'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import Loading from 'modules/layout/components/Page/Loading'

export enum CompensationRequestAction {
  CREATE = 'create',
  DESTROY = 'destroy',
}

const RequestModal = () => {
  return (
    <Modal
      title={i18n.t('time_tracking.modals.compensation.payroll.request.title')}
      description={i18n.t('time_tracking.modals.compensation.payroll.request.description')}
      illustration="clock-app"
    >
      <Loading />
    </Modal>
  )
}

export default observer(RequestModal)
